var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/select.scss";
// components
import PaymentMode from "../PaymentMode";
import AccordionComponent from "../AccordionComponent";
import InputComponent from "../InputComponent";
import FileUploadComponent from "../FileUploadComponent";
import PurchaseFee from "../PurchaseFee";
import { ClientDetails } from "../../components";
// helpers
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { ONE_THOUSAND_CRORE_RUPEE } from "../../constants";
import { formatIndiaNumber } from "../../utils";
import DraftAlready from "../../components/TableComponent/DraftAlready";
var PurchaseComponent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var setLeadId = _a.setLeadId, subCategoryId = _a.subCategoryId, setIsCxoButtonEnabled = _a.setIsCxoButtonEnabled;
    //
    var validateForm = useSelector(function (state) { return state.markets.purchase; }).validateForm;
    var _o = __read(useState(true), 2), isValid = _o[0], setIsValid = _o[1];
    var _p = __read(useState(false), 2), isValidFormNo = _p[0], setIsValidFormNo = _p[1];
    var _q = __read(useState(""), 2), errorMessageFormNo = _q[0], setErrorMessageFormNo = _q[1];
    var paymentProcess = useSelector(function (state) { return state.markets.payment; });
    var _r = useSelector(function (state) { return state.markets.AifPms; }), watchListData = _r.watchListData, draftOrderDetails = _r.draftOrderDetails, clientDetails = _r.clientDetails;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var paymentSuccess = useSelector(function (state) { return state.markets.payment; }).paymentSuccess;
    var selectLoginSearchData = useSelector(function (state) { return state.markets.leadservice; }).selectLoginSearchData;
    var handleOnChange = useCallback(function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        var minValue = (watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment)
            ? watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment
            : (_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.min_Investment_Amount;
        if (name === "amount") {
            var formatter = new Intl.NumberFormat("en-IN", {});
            var val = value.replace(/,/g, "");
            val = Number(val);
            var newVal = formatter.format(val);
            var numericValue = Number(value === null || value === void 0 ? void 0 : value.split(",").join(""));
            var isValid_1 = !isNaN(numericValue) && numericValue >= minValue;
            setIsValid(isValid_1);
            if (val <= ONE_THOUSAND_CRORE_RUPEE) {
                aifPmsDi.payment.updatePurchaseData(__assign(__assign({}, paymentProcess.purchase), { amount: newVal }));
            }
        }
        else if (name === "formNumber") {
            var isValidFormNo_1 = /^[a-zA-Z0-9]*$/.test(value);
            aifPmsDi.payment.updatePurchaseData(__assign(__assign({}, paymentProcess.purchase), { formNo: value }));
            if (isValidFormNo_1) {
                debounce(function () {
                    if (value) {
                        aifPmsDi.purchase
                            .validateForm({
                            formNo: value,
                            category_code: subCategoryId,
                            schemeid: Number(watchListData.schemeId),
                            ucccode: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ucccode,
                        })
                            .then(function (data) {
                            var _a, _b;
                            setIsValidFormNo((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.is_formNoExist);
                            setErrorMessageFormNo((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.message);
                        });
                    }
                });
            }
            else {
                setIsValidFormNo(true);
                setErrorMessageFormNo("Form number should not contain special characters.");
            }
        }
    }, [setIsValid, paymentProcess, setIsValidFormNo]);
    var handleOnChangeAmount = useCallback(function (event) {
        var _a;
        var value = event.target.value;
        var minValue = (watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment)
            ? watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment
            : (_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.min_Investment_Amount;
        var formattedValue = value.replace(/,/g, "");
        var newValue = formatIndiaNumber(formattedValue);
        var numericValue = Number(value === null || value === void 0 ? void 0 : value.split(",").join(""));
        var isValid = !isNaN(numericValue) && numericValue >= minValue;
        setIsValid(isValid);
        if (Number(formattedValue) <= ONE_THOUSAND_CRORE_RUPEE) {
            aifPmsDi.payment.updatePurchaseData(__assign(__assign({}, paymentProcess.purchase), { amount: newValue == "0" ? "" : newValue }));
        }
    }, [paymentProcess]);
    var handleKeyPress = function (event) {
        var charCode = event.charCode || event.keyCode;
        if ((charCode >= 48 && charCode <= 57) || charCode === 44) {
            return true;
        }
        event.preventDefault();
    };
    useEffect(function () {
        var _a;
        if (isValidFormNo) {
            setIsValidFormNo((_a = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _a === void 0 ? void 0 : _a.is_formNoExist);
        }
    }, [(_b = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _b === void 0 ? void 0 : _b.is_formNoExist]);
    var draft = useMemo(function () {
        var _a, _b, _c, _d;
        return (((_a = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _a === void 0 ? void 0 : _a.is_edit) === false ||
            ((_b = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _b === void 0 ? void 0 : _b.is_edit) === undefined ||
            ((_c = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _c === void 0 ? void 0 : _c.is_formNoExist) === false ||
            ((_d = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _d === void 0 ? void 0 : _d.is_formNoExist) === undefined);
    }, [(_c = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _c === void 0 ? void 0 : _c.is_edit, (_d = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _d === void 0 ? void 0 : _d.is_formNoExist]);
    return (React.createElement("div", { className: "rounded ".concat(!paymentSuccess ? "auto-height" : "auto-height-without-footer", "  width-375 position-relative ") },
        React.createElement("div", { className: "bg-white px-3 py-4-custom rounded box-shadow-light ".concat(((_e = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _e === void 0 ? void 0 : _e.is_edit) === true &&
                ((_f = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _f === void 0 ? void 0 : _f.is_formNoExist) === true &&
                "pb-0") },
            React.createElement(ClientDetails, { setIsCxoButtonEnabled: setIsCxoButtonEnabled, setLeadId: setLeadId }),
            draft && (React.createElement("form", { className: "p-top-20 form" },
                (((profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) && (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name)) ||
                    ((profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) && ((_g = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _g === void 0 ? void 0 : _g.trempcode)) ||
                    (clientDetails &&
                        (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) !== "true" &&
                        (profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) &&
                        draftOrderDetails &&
                        Object.keys(draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data).length == 0)) && (React.createElement("p", { className: "txt_medium-gray DMSanN_14_300 fw-300" },
                    "Login for:",
                    " ",
                    (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name)
                        ? selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name
                        : ((_h = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _h === void 0 ? void 0 : _h.trempcode)
                            ? "".concat((_j = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _j === void 0 ? void 0 : _j.trempname, " (").concat((_k = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _k === void 0 ? void 0 : _k.trempcode, ")")
                            : "")),
                React.createElement(InputComponent, { label: "Amount", placeholder: "Enter amount here", helperText: "Min. ".concat((watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment_in_cr) !== undefined
                        ? watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment_in_cr
                        : (_l = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _l === void 0 ? void 0 : _l.min_Investment_Amount_In_Cr), name: "amount", minAmount: (watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment)
                        ? watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment
                        : (_m = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _m === void 0 ? void 0 : _m.min_Investment_Amount, value: paymentProcess === null || paymentProcess === void 0 ? void 0 : paymentProcess.purchase.amount, required: true, isInvalid: !isValid, 
                    // integer
                    onKeyPress: handleKeyPress, onChangeEvent: handleOnChangeAmount }),
                React.createElement(InputComponent, { label: "Form No.", placeholder: "Enter Form no. here", minAmount: 200, minLength: 3, required: true, isInvalid: isValidFormNo, errorText: errorMessageFormNo, passErrorTextButHideErrTxt: true, helperText: React.createElement(React.Fragment, null, "Please provide the form number as listed on the manufacturer's portal."), name: "formNumber", onChangeEvent: handleOnChange, value: paymentProcess.purchase.formNo }),
                React.createElement(PaymentMode, null)))),
        draft ? (React.createElement(AccordionComponent, { items: [
                {
                    header: "Set Purchase Fees & Charges",
                    body: React.createElement(PurchaseFee, null),
                    optional: true,
                    leftIcon: "edel-icon-bars d-flex justify-content-center align-items-center fs-8",
                },
                {
                    header: "Upload Declaration",
                    body: React.createElement(FileUploadComponent, { fileSize: 5 }),
                    optional: false,
                    leftIcon: "edel-icon-medal-bookmark d-flex justify-content-center align-items-center txt_lavender-blue",
                },
            ] })) : (React.createElement(DraftAlready, null))));
};
export default PurchaseComponent;
